import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useLocation, useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

import { FullPageAppTemplate } from '../../templates'

const ClusterFoneApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const history = useHistory()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.CLUSTER_FONE}
      scope='cluster_fone'
      envKey={apps[AppId.CLUSTER_FONE].runtimeEnvKey}
      entryPath='./ClusterFoneApp'
      url={process.env.REACT_APP_CLUSTER_FONE_APP_DEV_PATH}
      cdnUrl={apps[AppId.CLUSTER_FONE].cdnUrl}
      appName={apps[AppId.CLUSTER_FONE].name}
      appProps={{
        user,
        history,
        appPath: apps[AppId.CLUSTER_FONE].path,
        initialPath: location.pathname,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location
          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}

export { ClusterFoneApp }
